import EmiSchemesRepository from "../creditengine/EmiSchemesRepository";
import DataTablesRepository from "./DataTablesRepository";
import DocumentServiceRepository from "./DocumentServiceRepository";
import ClientServiceRepository from "./ClientServiceRepository";
import LoanServiceRepository from "./LoanServiceRepository";
import CodeValueRepository from "./CodeValueRepository"
import SearchServiceRepository from "./SearchServiceRepository";

const repositories = {
  emiSchemes: EmiSchemesRepository,
  dataTables: DataTablesRepository,
  documentService: DocumentServiceRepository,
  clientService: ClientServiceRepository,
  loanService: LoanServiceRepository,
  codeService:CodeValueRepository,
  searchService: SearchServiceRepository,
  // other repositories ...
};

export const MifosRepositoryFactory = {
  EMI_SERVICE: "emiSchemes",
  DATA_TABLES: "dataTables",
  DOCUMENT_SERVICE: "documentService",
  CLIENT_SERVICE: "clientService",
  LOAN_SERVICE: "loanService",
  CODE_SERVICE: "codeService",
  SEARCH_SERVICE: "searchService",
  get: name => repositories[name]
};